var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "background-color" }, [_c('color-picker', { attrs: { "color": _vm.color }, on: { "change": function change(val) {
        return _vm.$emit('change', val);
      } } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };